import React from "react";
import { Outlet } from "react-router-dom";
import { FloatButton, Layout } from 'antd';
import MainHeader from "./MainHeader";
import MainFooter from "./MainFooter";
import { mdiArrowUpBold } from "@mdi/js";
import Icon from "@mdi/react";

const { Content } = Layout;

const MainLayout = () => {
  return (
    <Layout>
      <MainHeader/> 
      <Content>
        <Outlet/>
        <FloatButton.BackTop icon={<Icon path={mdiArrowUpBold} size="32px" />}/>
      </Content>
      {/* <MainFooter/>  */}
    </Layout>
  )
};

export default MainLayout;